<template>
  <div>
    <div class="add-img-user profile-img-edit">
      <b-img
        class="profile-pic height-150 width-150"
        fluid
        :src="displayImage"
        alt="profile-pic"
      />
      <div class="p-image">
        <b-button
          variant="none"
          class="upload-button iq-bg-primary position-relative"
        >
          <input
            type="file"
            @change="previewImage"
            class="h-100 position-absolute"
            accept="image/*"
            style="opacity: 0;"
          />
          File Upload
        </b-button>
      </div>
    </div>
    <div class="img-extension mt-3">
      <div class="d-inline-block align-items-center">
        <span>Only</span>
        <b-link href="javascript:void();">.jpg</b-link>
        <b-link href="javascript:void();">.png</b-link>
        <b-link href="javascript:void();">.jpeg</b-link>
        <span>allowed</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    def: {
      type: String,
      default: ""
    },
    field: {
      type: Object,
      default: () => ({})
    }
  },
  name: "CustomFileUpload",
  data() {
    return {
      user: {
        profile_image: ""
      }
    };
  },
  computed: {
    displayImage() {
      return this.user.profile_image || this.def;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.updateProfileImage(newValue);
      }
    }
  },
  methods: {
    updateProfileImage(newValue) {
      if (Array.isArray(newValue) && newValue.length > 0 && newValue[0]?.src) {
        this.user.profile_image = newValue[0].src;
      } else {
        this.user.profile_image = this.def || "";
      }
    },
    previewImage(event) {
      const input = event.target;
      if (input.files && input.files[0]) {
        const reader = new FileReader();

        reader.onload = e => {
          this.user.profile_image = e.target.result;

          this.$emit("input", [{ src: e.target.result }]);
        };

        reader.readAsDataURL(input.files[0]);
      }
    }
  }
};
</script>
